import { toast } from 'sonner';
import { showApiErrorToast } from '@/utils/errors';
import { downloadPaper } from '../api/question.api';

const NOT_ON_SERVER =
  'This paper is recorded but the file is not on the server yet. The collected files have not been migrated from the old system.';

export async function downloadPaperWithFeedback(
  uploadId: number | null,
  fileName: string | null,
): Promise<void> {
  if (uploadId === null) {
    toast.error(NOT_ON_SERVER);
    return;
  }

  try {
    await downloadPaper(uploadId, fileName ?? 'paper');
  } catch (error) {
    const status = (error as { response?: { status?: number } })?.response?.status;
    if (status === 404) {
      toast.error(NOT_ON_SERVER);
      return;
    }
    showApiErrorToast(error, 'Could not download this paper');
  }
}
